import { SettingsClient } from '@/data/web-api-client';
import AxiosClient from '@/data/AxiosClient';
import { Module } from 'vuex';

const settingsModule: Module<any, any> = {
  namespaced: true,
  state: {
    loading: true,
    initialised: false,
    data: {},
  },
  getters: {
    data: (state: any) => state.data,
    loading: (state: any) => state.loading,
  },
  mutations: {
    setData(state, data) {
      state.initialised = true;
      state.data = data;
    },
    setLoading(state, value) {
      state.loading = value;
    },
  },
  actions: {
    async fetch({ commit, dispatch, state }) {
      if (!state.initialised) {
        await dispatch('load');
      }
    },
    async load({ commit, dispatch }) {
      commit('setLoading', true);
      try {
        const client = new SettingsClient(undefined, AxiosClient);
        commit('setData', await client.get());
      } catch (err) {
        setTimeout(() => {
          dispatch('load');
        }, 3000);
      } finally {
        commit('setLoading', false);
      }
    },
  },
};

export default settingsModule;
